<template>
  <v-card-actions
    class="grey lighten-5 px-6 py-3 d-flex align-center"
    :class="dynamicClasses"
  >
    <div class="d-flex">
      <action-button
        color="accent"
        class="mr-4"
        @click="$emit('show-prisma-stats', revision.prismaStats)"
      >
        <v-icon left class="material-icons-outlined">
          assessment
        </v-icon>
        PRISMA
      </action-button>
      <action-button
        color="accent"
        @click="$emit('export-revision', revision)"
      >
        <v-icon left class="material-icons-outlined">
          system_update_alt
        </v-icon>
        Export
      </action-button>
    </div>
    <div v-if="!revision.isPublished" class="d-flex align-center">
      <span class="text-body-2 mr-4">
        {{ reviewedReferencesCount.toLocaleString() }} /
        {{ totalReferencesCount.toLocaleString() }} references
        reviewed
      </span>
      <progress-bar
        class="progress-bar mr-4"
        :value="progressPercentage"
        height="12"
      />
      <action-button
        color="primary"
        @click="$emit('publish-revision', revision)"
      >
        <v-icon left class="material-icons-outlined">
          publish
        </v-icon>
        {{ publishButtonText }}
      </action-button>
    </div>
  </v-card-actions>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import ProgressBar from '@/components/Common/ProgressBar';
import { Revision } from '@/models';

export default {
  name: 'RevisionCardActions',
  components: {
    ActionButton,
    ProgressBar,
  },
  props: {
    revision: {
      type: Revision,
      required: true,
    },
  },
  emits: ['show-prisma-stats', 'export-revision', 'publish-revision'],
  computed: {
    dynamicClasses() {
      return {
        'justify-space-between': !this.revision.isPublished,
        'justify-end': this.revision.isPublished,
      };
    },
    reviewedReferencesCount() {
      return (
        this.revision.prismaStats.reportsReviewed +
        this.revision.prismaStats.totalRecordsExcluded()
      );
    },
    totalReferencesCount() {
      return this.revision.prismaStats.totalNonDuplicateRecords();
    },
    progressPercentage() {
      return (
        (this.reviewedReferencesCount / this.totalReferencesCount) *
        100
      );
    },
    publishButtonText() {
      return this.progressPercentage >= 100
        ? 'Publish'
        : 'Publish anyway';
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-bar {
  width: 150px;
}
</style>
